import styles from './Notification.module.css';

export const Notification = () => {
	return (
		<>
			<h2 className={styles.notification}>There is no any feedback yet!</h2>
		</>
	);
};
